import "./App.scss";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutUs from './pages/AboutUs';
import HighlightRibbonOne from "./pages/HighlightRibbonOne";
import Services from "./pages/Services";
import FAQ from "./pages/FAQ";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import HighlightRibbonTwo from "./pages/HighlightRibbonTwo";
import HighlightRibbonThree from "./pages/HighlightRibbonThree";

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Home />
        <AboutUs />
        <HighlightRibbonOne />
        <Services />
        <HighlightRibbonTwo />
        {/* <Testimonials /> */}
        <FAQ />
        <HighlightRibbonThree />
        <Contact/>
      </main>
      <Footer />
    </>
  );
}
export default App;
